import graphql from "babel-plugin-relay/macro";

export default graphql`
query getAttendeesOverviewQuery($orgId: ID!, $propertyId: ID, $startAt: String!, $endAt: String!){
  attendeesOverview(orgId:$orgId, propertyId:$propertyId, startAt:$startAt, endAt:$endAt){
    attendedCount
    brokersCount
    hyeventsCount
    id
    notAttendedCount
    propertiesCount
    prospectsCount
    residentsCount
    rsvpsCount
  }
}
`